import React, { useEffect, useMemo, useRef } from 'react';
import { UIGameActionButton } from '../../../../common/UIGameActionButton/index.ts';
import { UIGameResourceCardsTooltipContent } from '../../../../common/UIGameResourceCardsTooltipContent/index.ts';
import { useActionButtonCommonErrors } from '../../utils.ts';
import { KNIGHT_LEVEL1_INACTIVE_IMAGE_PATH } from '../../../../utils/gamePieces.ts';
import { T, Tooltip } from '@colonist/ui';
import { getCardsForPiece } from '@colonist/game-card-types';
import { PieceTypes } from '@colonist/game-base-types';
import { useGameStore } from '../../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../../store/selectors/usePlayerValidators.ts';
import { ActionState } from '@colonist/game-states';
import { MapValidator, MechanicValidatorKnightPlayer } from '@colonist/game-mechanic-validators';
import { useCurrentStateValidator } from '../../../../store/selectors/useCurrentStateValidator.ts';
const cardToBuildKnight = getCardsForPiece(PieceTypes.Knight);
export const UIGameActionButtonKnightPlacement = ({ className, onDisabledChange })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const mechanicKnightState = useGameStore((state)=>state.gameState.mechanicKnightState);
    const mapState = useGameStore((state)=>state.gameState.mapState);
    const currentStateValidator = useCurrentStateValidator();
    const { getPlayerValidator, playerValidators } = usePlayerValidators();
    const playerValidator = getPlayerValidator(myColor);
    const tooltipRef = useRef(null);
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const { sendPlaceKnight, sendCancelAction, sendClearCornerHighlight } = useGameStore((state)=>state.gameSendEvent);
    const { actionStatus, level1KnightsThatCanBePlacedCount } = useMemo(()=>{
        const knightPlayerState = mechanicKnightState === null || mechanicKnightState === void 0 ? void 0 : mechanicKnightState[myColor];
        if (!knightPlayerState) {
            return {
                actionStatus: {
                    canTakeAction: false
                },
                level1KnightsThatCanBePlacedCount: 0
            };
        }
        const knightPlayerValidator = new MechanicValidatorKnightPlayer(playerValidator, new MapValidator(mapState), knightPlayerState);
        const useResources = true;
        const canPlaceKnightActionStatus = knightPlayerValidator.canPlayerPlaceNewKnight(useResources);
        const level1KnightsThatCanBePlaced = knightPlayerValidator.getAmountOfKnightsOfLevelThatCanBePlacedOnMap(1);
        return {
            actionStatus: canPlaceKnightActionStatus,
            level1KnightsThatCanBePlacedCount: level1KnightsThatCanBePlaced
        };
    }, [
        playerValidators,
        mapState,
        mechanicKnightState,
        myColor
    ]);
    const triggerFlickerCardsAnimation = ()=>{
        const notEnoughResources = !playerValidator.hasResourceCardsInHand(cardToBuildKnight);
        if (notEnoughResources) {
            var _tooltipRef_current;
            (_tooltipRef_current = tooltipRef.current) === null || _tooltipRef_current === void 0 ? void 0 : _tooltipRef_current.triggerFlickerAnimation();
        }
    };
    const disabled = hasCommonErrors || !actionStatus.canTakeAction;
    const actionState = currentStateValidator.getPlayerActionState(myColor);
    const isPlacingKnight = actionState === ActionState.PlaceKnight && !disabled;
    const icon = KNIGHT_LEVEL1_INACTIVE_IMAGE_PATH[myColor];
    const helperText = errorHelperText || actionStatus.errorMessageIfCantTakeAction;
    useEffect(()=>{
        onDisabledChange(disabled);
    }, [
        disabled
    ]);
    const onClick = ()=>{
        if (disabled) return;
        if (isPlacingKnight) {
            sendClearCornerHighlight();
            sendCancelAction();
        } else {
            sendPlaceKnight();
        }
    };
    return /*#__PURE__*/ React.createElement(Tooltip, {
        position: "bottom",
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.purchaseKnight"
        })
    }, /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: className,
        count: level1KnightsThatCanBePlacedCount,
        countColor: myColor,
        disabled: disabled,
        helperText: helperText,
        highlight: isPlacingKnight,
        iconPath: icon,
        onClickActionIfDisabled: triggerFlickerCardsAnimation,
        tooltipCustomMenuComponent: /*#__PURE__*/ React.createElement(UIGameResourceCardsTooltipContent, {
            cardInventory: playerValidator.resourceCards.cards,
            cardsToBuild: cardToBuildKnight,
            ref: tooltipRef
        }),
        onClick: onClick
    }));
};
